export const HOME_EN = {
    // ── the grid ──
    'home.grid.label': 'The page’s cards',
    'home.grid.empty.title': 'No cards on this page yet',
    'home.grid.empty.lede': 'Write what you want to follow, such as “pending leave by department” or “overdue customer invoices”. We propose the card and its size, and you see it with your own data before adding it.',
    'home.grid.edit.hint': 'Drag a card to move it, and its corner to resize it. With the keyboard: arrows move, Shift with arrows resizes.',
    'home.grid.edit.undo': 'Undo',
    'home.grid.edit.done': 'Done',
    'home.grid.cell': '{title}, size {size}',
    'home.grid.handle': 'Resize {title}',
    // ── a card ──
    'home.card.menu': 'Card options',
    'home.card.edit_ai': 'Edit by conversation',
    'home.card.edit_fields': 'Edit the fields',
    'home.card.size_to': 'Size {size}',
    'home.card.copy': 'Copy to another page',
    'home.card.remove': 'Remove the card',
    'home.card.empty': 'Nothing matches this card right now.',
    'home.card.more': 'and {n} more',
    'home.card.none': 'No value',
    'home.card.missing': 'Not in the data',
    'home.card.forbidden': 'You do not have access to this data. The card is kept, and shows once you are given access.',
    'home.card.unavailable': 'Not available right now: the unit this card reads is not answering. We try again automatically.',
    // ── why a card is not drawn ──
    'home.refused.not_a_list': 'This route does not answer a list, so this card cannot be drawn from it.',
    'home.refused.paged_grouping': 'This route answers one page of a longer list, so grouping it would describe the page and not the list. Choose a number or a table.',
    'home.refused.paged_filter': 'This route answers one page of a longer list, so filtering here would narrow the page and not the list. Put the condition in the route’s parameters.',
    'home.refused.paged_sort': 'This route answers one page of a longer list, so sorting here would order the page and not the list.',
    'home.refused.no_total': 'This route does not say how many there are in all, so the figure is not available.',
    'home.refused.no_totals': 'This route does not give this figure for the whole list, so it is not available.',
    'home.refused.not_a_number': 'The field “{field}” is not a number in every record, so it cannot be added up.',
    'home.refused.not_groupable': 'The field “{field}” is not a single value to group by.',
    'home.refused.rejected': 'The unit refused this read.',
    // ── a card's own markup and script ──
    'home.card.yes': 'Yes',
    'home.card.no': 'No',
    'home.refused.markup': 'This card’s own layout was not drawn: part of it is not allowed. Its figures are shown the usual way.',
    'home.script.frame': '{title} — drawn by an isolated script',
};
export const HOME_AR = {
    // ── the grid ──
    'home.grid.label': 'بطاقات الصفحة',
    'home.grid.empty.title': 'لا بطاقات في هذه الصفحة بعد',
    'home.grid.empty.lede': 'اكتب ما تريد متابعته، مثل «طلبات الإجازة المعلقة لكل إدارة» أو «فواتير العملاء المتأخرة». نقترح عليك البطاقة وحجمها وتراها ببياناتك قبل إضافتها.',
    'home.grid.edit.hint': 'اسحب البطاقة لتغيير مكانها، واسحب زاويتها لتغيير حجمها. وبلوحة المفاتيح: الأسهم للنقل، وShift مع الأسهم للحجم.',
    'home.grid.edit.undo': 'تراجع',
    'home.grid.edit.done': 'تم',
    'home.grid.cell': '{title}، الحجم {size}',
    'home.grid.handle': 'غيّر حجم {title}',
    // ── a card ──
    'home.card.menu': 'خيارات البطاقة',
    'home.card.edit_ai': 'تعديل بالمحادثة',
    'home.card.edit_fields': 'عدّل الحقول',
    'home.card.size_to': 'الحجم {size}',
    'home.card.copy': 'نسخ إلى صفحة أخرى',
    'home.card.remove': 'إزالة البطاقة',
    'home.card.empty': 'لا شيء يطابق هذه البطاقة الآن.',
    'home.card.more': 'و{n} أخرى',
    'home.card.none': 'بلا قيمة',
    'home.card.missing': 'غير موجود',
    'home.card.forbidden': 'لا تملك الوصول إلى هذه البيانات. البطاقة محفوظة، وتظهر إن مُنحت الصلاحية.',
    'home.card.unavailable': 'غير متاح الآن: الوحدة التي تقرأ منها البطاقة لا تستجيب. نعيد المحاولة تلقائياً.',
    // ── why a card is not drawn ──
    'home.refused.not_a_list': 'هذا المسار لا يجيب بقائمة، فلا تُرسم منه هذه البطاقة.',
    'home.refused.paged_grouping': 'هذا المسار يجيب بصفحة من قائمة أطول، فالتجميع منها يصف الصفحة لا القائمة. اختر رقماً أو جدولاً.',
    'home.refused.paged_filter': 'هذا المسار يجيب بصفحة من قائمة أطول، فالتصفية هنا تضيّق الصفحة لا القائمة. ضع الشرط في معاملات المسار.',
    'home.refused.paged_sort': 'هذا المسار يجيب بصفحة من قائمة أطول، فالترتيب هنا يرتّب الصفحة لا القائمة.',
    'home.refused.no_total': 'هذا المسار لا يذكر العدد الكلي، فالرقم غير متاح.',
    'home.refused.no_totals': 'هذا المسار لا يذكر هذا الرقم للقائمة كلها، فهو غير متاح.',
    'home.refused.not_a_number': 'الحقل «{field}» ليس رقماً في كل السجلات، فلا يُحسب.',
    'home.refused.not_groupable': 'الحقل «{field}» ليس قيمة واحدة يُجمَّع بها.',
    'home.refused.rejected': 'رفضت الوحدة هذه القراءة.',
    // ── تنسيق البطاقة الخاص وسكربتها ──
    'home.card.yes': 'نعم',
    'home.card.no': 'لا',
    'home.refused.markup': 'لم يُرسم تنسيق هذه البطاقة الخاص: فيه ما لا يُسمح به. تظهر أرقامها بالطريقة المعتادة.',
    'home.script.frame': '{title} — يرسمها سكربت معزول',
};
//# sourceMappingURL=i18n-home.js.map